module.exports = __webpack_public_path__ + "img/bg-circles.3204fa33.svg";